interface Texts {
	readonly [language: string]: { readonly [text: string]: string }
}

export const texts: Texts = {
	// Do not use!
	'en': {},
	// Italian
	'it': {
		'Follow': 'Segui',
		'Try': 'Prova',
		'Learn': 'Impara',
		'Install': 'Installa',
		'Donate': 'Dona',
		'Watch YouTube videos': 'Guarda i video di YouTube',
		'Directly in your browser': 'Direttamente nel tuo browser',
		'Support': 'Supporta',
		'Sponsor on Patreon': 'Diventa sponsor su Patreon',
		'Install on your device': 'Installa sul tuo dispositivo',
		'Hi': 'Ciao',
	},
	// Spain
	'es': {
		'Follow': 'Seguir',
		'Try': 'Probar',
		'Learn': 'Aprender',
		'Install': 'Instalar',
		'Donate': 'Donar',
		'Watch YouTube videos': 'Ver videos en YouTube',
		'Directly in your browser': 'Directamente en tu navegador',
		'Support': 'Apoyar',
		'Sponsor on Patreon': 'Patrocinar en Patreon',
		'Install on your device': 'Instalar en tu dispositivo',
		'Hi': 'Hola',
	},
	// German
	'de': {
		'Follow': 'Folgen',
		'Try': 'Versuchen',
		'Learn': 'Lernen',
		'Install': 'Installieren',
		'Donate': 'Spenden',
		'Watch YouTube videos': 'YouTube-Videos ansehen',
		'Directly in your browser': 'Direkt in Ihrem Browser',
		'Support': 'Unterstützen',
		'Sponsor on Patreon': 'Auf Patreon sponsern',
		'Install on your device': 'Auf Ihrem Gerät installieren',
		'Hi': 'Hallo',
	},
	// French
	'fr': {
		'Follow': 'Suivre',
		'Try': 'Essayer',
		'Learn': 'Apprendre',
		'Install': 'Installer',
		'Donate': 'Faire un don',
		'Watch YouTube videos': 'Regarder des vidéos sur YouTube',
		'Directly in your browser': 'Directement dans votre navigateur',
		'Support': 'Soutenir',
		'Sponsor on Patreon': 'Sponsoriser sur Patreon',
		'Install on your device': 'Installer sur votre appareil',
		'Hi': 'Salut',
	},
	// Japanese
	'ja': {
		'Follow': 'フォロー',
		'Try': '試す',
		'Learn': '学ぶ',
		'Install': 'インストール',
		'Donate': '寄付する',
		'Watch YouTube videos': 'YouTubeビデオを視聴する',
		'Directly in your browser': '直接あなたのブラウザで',
		'Support': 'サポート',
		'Sponsor on Patreon': 'Patreonのスポンサーになる',
		'Install on your device': 'あなたのデバイスにインストールする',
		'Hi': 'こんにちは',
	},
	// Kazakh
	'kk': {
		'Follow': 'Көзіре қатысты',
		'Try': 'Көріңіз',
		'Learn': 'Оқу',
		'Install': 'Орнату',
		'Donate': 'Қолжетімділік көрсету',
		'Watch YouTube videos': 'YouTube бейнелерін көру',
		'Directly in your browser': 'Тінтуірде тіркеліңіз',
		'Support': 'Қолдау көрсету',
		'Sponsor on Patreon': 'Patreonда спонсор болу',
		'Install on your device': 'Өзіңіздің құрылғыңызға орнатыңыз',
		'Hi': 'Сәлем',
	},
	// Russian
	'ru': {
		'Follow': 'Подписаться',
		'Try': 'Попробовать',
		'Learn': 'Научиться',
		'Install': 'Установить',
		'Donate': 'Пожертвовать',
		'Watch YouTube videos': 'Смотреть на YouTube',
		'Directly in your browser': 'Прямо в твоём браузере',
		'Support': 'Поддержать',
		'Sponsor on Patreon': 'Стать спонсором на Patreon',
		'Install on your device': 'Установить на своё устройство',
		'Hi': 'Привет',
	},
	// Arabic
	'ar': {
		'Follow': 'تابع',
		'Try': 'حاول',
		'Learn': 'تعلم',
		'Install': 'تثبيت',
		'Donate': 'تبرع',
		'Watch YouTube videos': 'شاهد مقاطع يوتيوب',
		'Directly in your browser': 'مباشرة في متصفحك',
		'Support': 'دعم',
		'Sponsor on Patreon': 'رعاية على Patreon',
		'Install on your device': 'تثبيت على جهازك',
		'Hi': 'مرحبا',
	},
	// Ukrainian
	'uk': {
		'Follow': 'Слідкувати',
		'Try': 'Спробувати',
		'Learn': 'Вивчати',
		'Install': 'Встановити',
		'Donate': 'Пожертвувати',
		'Watch YouTube videos': 'Дивитися відео на YouTube',
		'Directly in your browser': 'Безпосередньо у вашому браузері',
		'Support': 'Підтримати',
		'Sponsor on Patreon': 'Стати спонсором на Patreon',
		'Install on your device': 'Встановити на ваш пристрій',
		'Hi': 'Привіт',
	},
	// Chinese
	'zh': {
		'Follow': '关注',
		'Try': '实验',
		'Learn': '学会',
		'Install': '安装',
		'Donate': '捐赠',
		'Watch YouTube videos': '观看 YouTube 视频',
		'Directly in your browser': '直接在浏览器中',
		'Support': '支持',
		'Sponsor on Patreon': 'Patreon 的赞助商',
		'Install on your device': '在您的设备上安装',
		'Hi': '你好',
	},
	// Korean
	'ko': {
		'Follow': '팔로우',
		'Try': '시도해보세요',
		'Learn': '배우기',
		'Install': '설치',
		'Donate': '기부하기',
		'Watch YouTube videos': '유튜브 동영상 시청',
		'Directly in your browser': '브라우저에서 직접',
		'Support': '지원',
		'Sponsor on Patreon': 'Patreon에서 후원하기',
		'Install on your device': '장치에 설치',
		'Hi': '안녕하세요',
	},
	// Hindi
	'hi': {
		'Follow': 'फॉलो करें',
		'Try': 'प्रयास करें',
		'Learn': 'सीखें',
		'Install': 'इंस्टॉल करें',
		'Donate': 'दान करें',
		'Watch YouTube videos': 'YouTube वीडियो देखें',
		'Directly in your browser': 'अपने ब्राउज़र में सीधे',
		'Support': 'समर्थन',
		'Sponsor on Patreon': 'पेट्रियॉन पर प्रायोजक',
		'Install on your device': 'अपनी डिवाइस पर इंस्टॉल करें',
		'Hi': 'नमस्ते',
	},
	// Portuguese
	'pt': {
		'Follow': 'Seguir',
		'Try': 'Experimentar',
		'Learn': 'Aprender',
		'Install': 'Instalar',
		'Donate': 'Doar',
		'Watch YouTube videos': 'Assistir a vídeos do YouTube',
		'Directly in your browser': 'Diretamente no seu navegador',
		'Support': 'Apoiar',
		'Sponsor on Patreon': 'Patrocinar no Patreon',
		'Install on your device': 'Instalar no seu dispositivo',
		'Hi': 'Oi',
	},
	// Polish
	'pl': {
		'Follow': 'Follować',
		'Try': 'Spróbować',
		'Learn': 'Uczyć się',
		'Install': 'Zainstalować',
		'Donate': 'Darowizna',
		'Watch YouTube videos': 'Oglądać video z YouTube',
		'Directly in your browser': 'Bezpośrednio w przeglądarce',
		'Support': 'Pomoc',
		'Sponsor on Patreon': 'Sponsor na Patreonie',
		'Install on your device': 'Zainstaluj na swoim urządzeniu',
		'Hi': 'Cześć',
	},
	// Slovak
	'sk': {
		'Follow': 'Sledovať',
		'Try': 'Vyskúšať',
		'Learn': 'Učte sa',
		'Install': 'Nainštalovať',
		'Donate': 'Darcovstvo',
		'Watch YouTube videos': 'Pozrite si video na YouTube',
		'Directly in your browser': 'Priamo v prehliadači',
		'Support': 'Pomoc',
		'Sponsor on Patreon': 'Sponzor na Patreone',
		'Install on your device': 'Nainštalujte do svojho zariadenia',
		'Hi': 'Ahoj',
	},
	// Czech
	'cs': {
		'Follow': 'Sledovat',
		'Try': 'Vyzkoušet',
		'Learn': 'Učte se',
		'Install': 'Nainstalovat',
		'Donate': 'Dárcovství',
		'Watch YouTube videos': 'Podívejte se na video na YouTube',
		'Directly in your browser': 'Přímo v prohlížeči',
		'Support': 'Pomoc',
		'Sponsor on Patreon': 'Sponzor na Patreonu',
		'Install on your device': 'Nainstalujte do svého zařízení',
		'Hi': 'Ahoj',
	},
	// Latvian
	'lv': {
		'Follow': 'Sekot',
		'Try': 'Izmēģināt',
		'Learn': 'Mācīties',
		'Install': 'Instalēt',
		'Donate': 'Ziedot',
		'Watch YouTube videos': 'Skatīties YouTube video',
		'Directly in your browser': 'Tieši jūsu pārlūkā',
		'Support': 'Atbalstīt',
		'Sponsor on Patreon': 'Kļūt par sponsoru Patreonā',
		'Install on your device': 'Instalēt uz jūsu ierīces',
		'Hi': 'Sveiki',
	},
	// Lithuanian
	'lt': {
		'Follow': 'Sekti',
		'Try': 'Išbandyti',
		'Learn': 'Mokytis',
		'Install': 'Įdiegti',
		'Donate': 'Aukoti',
		'Watch YouTube videos': 'Žiūrėti YouTube vaizdo įrašus',
		'Directly in your browser': 'Tiesiogiai naršyklėje',
		'Support': 'Palaikyti',
		'Sponsor on Patreon': 'Rėmėti per Patreon',
		'Install on your device': 'Įdiegti į savo įrenginį',
		'Hi': 'Labas',
	},
	// Estonian
	'et': {
		'Follow': 'Jälgi',
		'Try': 'Proovi',
		'Learn': 'Õpi',
		'Install': 'Paigalda',
		'Donate': 'Anneta',
		'Watch YouTube videos': 'Vaata YouTube videoid',
		'Directly in your browser': 'Otseselt brauseris',
		'Support': 'Toeta',
		'Sponsor on Patreon': 'Toeta Patreonis',
		'Install on your device': 'Paigalda oma seadmesse',
		'Hi': 'Tere',
	},
	// Greek
	'el': {
		'Follow': 'Ακολουθήστε',
		'Try': 'Δοκιμάστε',
		'Learn': 'Μάθετε',
		'Install': 'Εγκαταστήστε',
		'Donate': 'Δωρίστε',
		'Watch YouTube videos': 'Δείτε βίντεο στο YouTube',
		'Directly in your browser': 'Κατευθείαν στο φυλλομετρητή σας',
		'Support': 'Υποστηρίξτε',
		'Sponsor on Patreon': 'Χρηματοδοτήστε στο Patreon',
		'Install on your device': 'Εγκαταστήστε στη συσκευή σας',
		'Hi': 'Γεια',
	},
	// Finnish
	'fi': {
		'Follow': 'Seuraa',
		'Try': 'Kokeile',
		'Learn': 'Opiskele',
		'Install': 'Asenna',
		'Donate': 'Lahjoita',
		'Watch YouTube videos': 'Katso YouTube-videoita',
		'Directly in your browser': 'Suoraan selaimessasi',
		'Support': 'Tue',
		'Sponsor on Patreon': 'Sponsoroi Patreonissa',
		'Install on your device': 'Asenna laitteellesi',
		'Hi': 'Hei',
	},
	// Swedish
	'sv': {
		'Follow': 'Följ',
		'Try': 'Prova',
		'Learn': 'Lär',
		'Install': 'Installera',
		'Donate': 'Donera',
		'Watch YouTube videos': 'Titta på YouTube-videor',
		'Directly in your browser': 'Direkt i din webbläsare',
		'Support': 'Stöd',
		'Sponsor on Patreon': 'Sponsra på Patreon',
		'Install on your device': 'Installera på din enhet',
		'Hi': 'Hej',
	},
	// Danish
	'da': {
		'Follow': 'Følg',
		'Try': 'Prøv',
		'Learn': 'Lær',
		'Install': 'Installer',
		'Donate': 'Donér',
		'Watch YouTube videos': 'Se YouTube-videoer',
		'Directly in your browser': 'Direkte i din browser',
		'Support': 'Støt',
		'Sponsor on Patreon': 'Sponsor på Patreon',
		'Install on your device': 'Installer på din enhed',
		'Hi': 'Hej',
	},
} as const
